module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/step-img-2-d4603f42e3bf9d0fcde5451a801665aa.png";